export const COMMERCIAL_NAMES: { [key: string]: string } = {
    'liens': 'Internet & Connectivité',
    'mobiles': 'Téléphonie Mobile',
    'voix': 'Téléphonie Fixe',
    'cybersecurité': 'Cybersécurité',
    'cybersécurité': 'Cybersécurité',
    'equipement': 'Équipements',
    'équipement': 'Équipements',
    'materiel': 'Matériel',
    'matériel': 'Matériel',
};

export const getCommercialName = (technicalName: string): string => {
    const normalized = technicalName.toLowerCase().trim();
    return COMMERCIAL_NAMES[normalized] || technicalName;
};
